// import utils
import dayjs from 'dayjs';
import { t } from 'i18next';

// import types
import {
  ErrorMessage,
  ShouldDisableDateInMonthOrWeek
} from './MonthOrWeekRange.types';
import { RangeScope } from './MonthOrWeekRange.consts';

export const minDate = dayjs().subtract(10, 'year').toDate();
export const maxDate = dayjs().add(10, 'year').toDate();

export const shouldDisableDateInMonthOrWeek = ({
  isSetToMonth,
  day,
  position
}: ShouldDisableDateInMonthOrWeek) => {
  const dayjsDay = dayjs(day);

  const firstDay = dayjsDay.startOf(isSetToMonth ? 'month' : 'week');
  const lastDay = dayjsDay.endOf(isSetToMonth ? 'month' : 'week');

  if (position === 'start') return !dayjsDay.isSame(firstDay, 'day');
  if (position === 'end') return !dayjsDay.isSame(lastDay, 'day');

  return false;
};

export const scopePositionMap = {
  [RangeScope.MONTH]: {
    start: 'adminPortal.realization.errors.startOfMonthError',
    end: 'adminPortal.realization.errors.endOfMonthError'
  },
  [RangeScope.WEEK]: {
    start: 'adminPortal.realization.errors.startOfWeekError',
    end: 'adminPortal.realization.errors.endOfWeekError'
  }
} as const;

export const errorMessage = ({ errorType, scope, position }: ErrorMessage) => {
  switch (errorType) {
    case 'maxDate':
    case 'minDate':
      return t('adminPortal.realization.errors.dateRangeMax10Years');

    case 'shouldDisableDate':
      if (position && scopePositionMap[scope])
        return t(scopePositionMap[scope][position]);
      return;

    case 'invalidDate':
      return t('adminPortal.realization.errors.invalidDate');

    case 'invalidRange':
      return t('adminPortal.realization.errors.invalidRange');

    default:
      return;
  }
};
